import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Typography, Link as MUILink, Container } from "@mui/material";
import { useTranslation } from "react-i18next";

// 🎨 Estilos coherentes con el Navbar
const FOOTER_BG = "#1A1A1A";
const TEXT_COLOR = "#ffffff";
const LINK_COLOR = "#bbbbbb";

const Footer = () => {
  const { t } = useTranslation("footer");

  return (
    <Box
      component="footer"
      className="main-footer"
      sx={{
        backgroundColor: FOOTER_BG,
        color: TEXT_COLOR,
        py: 3,
        mt: 0,
      }}
    >
    <Container maxWidth="lg">
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column-reverse", sm: "row" }, // 👈 Esto invierte en mobile
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          textAlign: { xs: "center", sm: "left" },
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 400 }}>
          © {new Date().getFullYear()} Pitchest. {t("rightsReserved")}
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            gap: { xs: 1, sm: 3 },
          }}
        >
          <MUILink component={RouterLink} to="/contact" underline="hover" color={LINK_COLOR}>
            {t("contact")}
          </MUILink>
          <MUILink component={RouterLink} to="/pricing" underline="hover" color={LINK_COLOR}>
            {t("pricing")}
          </MUILink>
          <MUILink component={RouterLink} to="/privacy-policy" underline="hover" color={LINK_COLOR}>
            {t("privacy")}
          </MUILink>
          <MUILink component={RouterLink} to="/terms" underline="hover" color={LINK_COLOR}>
            {t("terms")}
          </MUILink>
        </Box>
      </Box>
    </Container>

    </Box>
  );
};

export default Footer;
